//应用
export const materialOption = (safe) => {
	return {
		card: true,
		border: true,
		index: false,
		stripe: true,
		addBtnText: '上传素材',
		menuAlign: 'center',
		searchLabelWidth: 120,
		menuWidth: 300,
		searchMenuSpan: 6,
		searchMenuPosition: 'right',
		labelWidth: 140,
		align: 'center',
		excelBtn: true,
		column: [
			{
				label: '素材名称',
				prop: 'materialName',
				search: true,
				rules: [
					{
						required: true,
						message: '请输入素材名称',
						trigger: 'blur',
					},
				],
			},
			{
				label: '素材',
				prop: 'materialImg',
				fileType: 'img',
				type: 'upload',
				listType: 'picture-img',
				action: '/dist/material/uploadFile',
				data: {
					type: 1,
				},
				tip: '需要合成二维码请上传750*1334的素材',
				accept: ['.png', '.jpeg', '.gif', '.jpg'],
				rules: [
					{
						required: true,
						message: '请选择要上传的素材',
						trigger: 'blur',
					},
				],
			},

			{
				label: '素材类型',
				prop: 'materialType',
				type: 'checkbox',
				props: {
					label: 'name',
					value: 'id',
				},
				search: true,
				rules: [
					{
						required: true,
						message: '请选择素材类型',
						trigger: 'blur',
					},
				],
				dicFormatter: ({data}) => {
					return data
				},
				dicUrl: `/dist/material/type/config`,
			},
			// {
			//   label: "内容标签",
			//   prop: "materialLabelE",
			//   type: "checkbox",
			//   addDisplay: false,
			//   editDisplay: false,
			//   hide: true,
			//   showColumn: false,
			//   dicData: [],
			// },
			// {
			//   label: "内容标签",
			//   prop: "materialLabel",
			//   type: "checkbox",
			//   search: true,
			//   props: {
			//     label: "name",
			//     value: "id",
			//   },
			//   dicFormatter: ({ data }) => {
			//     let arr = [];
			//     data.forEach((item) => {
			//       if (item.childs) {
			//         arr = arr.concat(item.childs);
			//       }
			//     });
			//     return arr;
			//   },
			//   dicUrl: `/dist/material/type/config`,
			// },
			{
				label: '产品属性',
				showColumn: false,
				prop: 'insureType',
				filterable: true,
				multiple: true,
				type: 'select',
				//折叠
				overHidden: true,
				dicUrl: `/dist/insureType/list`,
				props: {
					label: 'abbreviation',
					value: 'type',
				},
				dicFormatter: function ({data}) {
					return data.map(({abbreviation, type}) => ({abbreviation: abbreviation + '', type: type + ''}))
				},
			},
			{
				label: '关联产品',
				prop: 'productIds',
				multiple: true,
				filterable: true,
				type: 'select',
				dataType: 'string',
				dicData: [],
				//折叠
				overHidden: true,

				// dicUrl: `/dist/distProduct/listInfoAll`,
				props: {
					label: 'title',
					value: 'id',
				},
				rules: [
					{
						required: true,
						message: '请选择关联产品',
						trigger: 'blur',
					},
				],
				// dicFormatter: function ({data}) {
				//   return data.map(({abbreviation, type}) => ({abbreviation: abbreviation + "", type: type + ""}));
				// },
			},
			{
				label: '素材宣传语',
				prop: 'materialIntro',
				type: 'textarea',

				span: 24,
			},
			{
				label: '告知提醒文案',
				prop: 'copyRemind',
				type: 'textarea',
				width: 200,
				overHidden: true,
				span: 24,
			},

			{
				label: '状态',
				prop: 'status',
				type: 'switch',
				value: 1,
				rules: [
					{
						required: true,
						message: '请选择状态',
						trigger: 'blur',
					},
				],
				dicData: [
					{
						label: '关闭',
						value: 0,
					},
					{
						label: '开启',
						value: 1,
					},
				],
			},
			{
				label: '合成开关',
				prop: 'switchType',
				type: 'switch',
				value: 1,
				rules: [
					{
						required: true,
						message: '请选择合成开关',
						trigger: 'blur',
					},
				],
				control: (val, form) => {
					if (val == 0) {
						return {
							qrcodePosition: {
								addDisplay: false,
								editDisplay: false,
							},
						}
					} else {
						return {
							qrcodePosition: {
								addDisplay: true,
								editDisplay: true,
							},
						}
					}
				},
				dicData: [
					{
						label: '关',
						value: 0,
					},
					{
						label: '开',
						value: 1,
					},
				],
			},

			{
				label: '个人二维码位置',
				prop: 'qrcodePosition',
				hide: true,
				span: 24,
				value: 1,
				addDisplay:true,
				editDisplay:true,
				rules: [
					{
						required: true,
						message: '请选择个人二维码位置',
						trigger: 'blur',
					},
				],
				dicData: [
					//嵌入式
					{value: 1, label: '左下方'},
					{value: 2, label: '底部中间'},
					{value: 3, label: '右下方'},
					//非嵌入式
					{value: 4, label: '左下方'},
					{value: 5, label: '右下方'},
				],
				showColumn: false,
			},

			{
				label: '创建时间',
				prop: 'createAt',
				type: 'datetime',
				format: 'yyyy-MM-dd',
				valueFormat: 'yyyy-MM-dd',
				search: true,
				editDisplay: false,
				addDisplay: false,
			},
		],
	}
}
